import { LogoutOutlined } from "@ant-design/icons";
import { Avatar, Dropdown, Menu, Space, Typography } from "antd";
import { OBJ_COLOR } from "commons/constants";
// import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store";
import styled from "styled-components";
import { removeUser } from "slice";

interface BoxIconProps {
	backgroundColor: string;
}

const BoxIcon = styled.div`
	width: 38px;
	height: 38px;
	background: ${({ backgroundColor }: BoxIconProps) => backgroundColor};
	border-radius: 7px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
`;

const { Text } = Typography;

interface LabelProps {
	title: string;
	value?: string;
}

const Label = ({ title, value }: LabelProps) => {
	return (
		<Space direction={"vertical"}>
			<Text type="secondary">{title}</Text>
			<Text>{value}</Text>
		</Space>
	);
};

export const SectionRight = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const user = useAppSelector((state) => state.user);

	const handleSignOut = () => {
		dispatch(removeUser());
		navigate("/auth/login");
	};

	const menu = (
		<Menu
			items={[
				{
					key: "id",
					label: <Label title="User Id" value={user?.id as string} />,
				},
				{
					type: "divider",
				},
				{
					key: "name",
					label: <Label title="Name" value={user?.name as string} />,
				},
				{
					type: "divider",
				},
				{
					key: "logout",
					icon: <LogoutOutlined />,
					label: "Logout",
					onClick: handleSignOut,
				},
			]}
		/>
	);

	return (
		<Space>
			<Dropdown overlay={menu} trigger={["click"]}>
				<BoxIcon backgroundColor={OBJ_COLOR.SUCCESS_LIGHT}>
					<Avatar style={{ backgroundColor: OBJ_COLOR.SUCCESS }} size="small">
						{user?.name.substring(0, 1)}
					</Avatar>
				</BoxIcon>
			</Dropdown>
		</Space>
	);
};
